<template>
    <button
        :class="['wishlist-icon__cta', customClass]"
        @click.stop="toggleWishlist"
        :aria-label="`${isWishlisted ? `Remove ${product.title} from wishlist` : `Add ${product.title} to wishlist`}`" 
        :aria-pressed="isWishlisted ? true : false" 
        :disabled="isLoading"
    >
        <svg aria-hidden="true">
            <use :xlink:href="isWishlisted ? '#wishlist-selected-icon' : '#wishlist-icon'"></use>
        </svg>
    </button>
</template>

<script setup>
import { toRefs, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const props = defineProps({
    product: {
        type: Object,
        default: {}
    },
    selectedVariantDetails: {
        type: Object,
        default: {}
    },
    customClass: {
        type: String,
        default: ''
    },
    showOptions: {
        type: Boolean,
        default: false
    },
    firstOptionName: {
        type: String,
        default: ''
    }
});

const { product, selectedVariantDetails, showOptions, firstOptionName } = toRefs(props);
const currentVariantDetails = ref(selectedVariantDetails.value);

const isLoading = computed(() => store.state.isWishlistLoading);
const wishlistedProducts = computed(() => store.state.wishlistProducts);
const isWishlisted = computed(() => {
    // Find the item in wishlistedProducts matching the conditions
    return wishlistedProducts.value?.find(item => {
        // Check if options are shown and if this item matches the current product
        if (showOptions.value && item.empi == product.value.id) {
            const { variantDetails } = item.cprops;

            // If 'Color' is the first option, match it with the selected variant details
            if (firstOptionName.value === 'Color') {
                return variantDetails[firstOptionName.value] === selectedVariantDetails.value[firstOptionName.value];
            }

            // For non-Color options, return true when the item matches the current product variant
            return true;
        }

        // Fallback to checking if this item's 'epi' matches the selected variant
        return item.epi == currentVariantDetails.value?.selectedVariant?.id;
    });
});

const toggleWishlist = (event) => {
    event.preventDefault();
    window.toggleWishlist(product.value, currentVariantDetails.value, isWishlisted.value, showOptions.value, firstOptionName.value);
};

watch(selectedVariantDetails, (val) => {
    currentVariantDetails.value = val;
});

</script>
